export const initialState = {
  clientUsers: {},
  clientUsersList: {},
};

const state = () => ({ ...initialState });

export default state();
